<template>
  <div styleName="opt_toolbar" :data-lang="$i18n.locale" v-if="isShow">
    <!--<span styleName="opt_toolbar_ppt" v-if="userRole !== 2" @click="handleCourseManage"></span>-->
    <span styleName="opt_toolbar_span opt_toolbar_video_box" @click="openVideoBox" :data-role="videoBoxStatus"></span>
    <!-- <span styleName="opt_toolbar_span opt_toolbar_screen_box" @click="screenBox" :data-role="screenActive"></span> -->
    <span styleName="opt_toolbar_span opt_toolbar_clear" v-if="!getSn" @click="clearCanvas" :data-role="Boolean(roomDetail.data.lessonSerialNumber) + ''"></span>
    <span styleName="opt_toolbar_span opt_toolbar_video" @click="handleVideo" :data-role="cameraStatus"></span>
    <span styleName="opt_toolbar_span opt_toolbar_slient" @click="openSilenceList" :data-role="silenceListActive"></span>
    <span styleName="opt_toolbar_span opt_toolbar_hongbao" :data-role="hongbaoActive" :data-click='!hongstyle' @click="handleHongbaoModal">
      <em v-if="hongstyle">{{hongbaoNum}}</em>
      <canvas ref="canvas" styleName="opt_toolbar_hongbao_countdown" v-show="isshowcount" width="50" height="50"></canvas>
    </span>
    <span styleName="opt_toolbar_span opt_toolbar_setting" @click="handleSetting" :data-role="settingActive"></span>
    <span styleName="opt_toolbar_span opt_toolbar_endclass" @click="endClass"></span>
    <!-- 红包模态框 -->
    <div styleName="hongbao_modal" v-if="hongbaoActive">
      <span styleName="hongbao_modal_bg"></span>
      <span styleName="hongbao_modal_text">
        <span styleName="hongbao_modal_body">{{hongbaoBodyText}}</span>
        <span styleName="hongbao_modal_footer">
          <span styleName="hongbao_modal_confirm" @click="handleHongbao" v-if="hongbaoConfirmState">{{hongbaoConfirmText}}</span>
          <span styleName="hongbao_modal_close" @click="handleHongbaoModalClose" v-if="ifshowCount">{{hongbaoCloseText}}s</span>
          <span styleName="hongbao_modal_later" @click="handleHongbaoModalClose" v-if="ifShowLater">{{hongbaoLaterText}}</span>
        </span>
      </span>
    </div>
    <!-- 红包模态框 -->
  </div>
</template>
<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import * as types from '../../constants'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import sensorLog from '@/utils/sensorLog'
import { signalSdk } from '@/utils/getSDK'
import debounce from 'lodash.debounce'
import axios from '@/api'
import { setInterval, clearInterval, setTimeout } from 'timers';

export default {
  mixins: [CSSModules(styles)],
  data: () => {
    return {
      videoActive: false,
      settingActive: false,
      silenceListActive: false,
      screenActive: false,
      hongbaoActive: false,
      hongbaoBodyText: '',
      hongbaoConfirmText: '',
      // hongbaoForbid: false,
      hongbaoNum: 0,// 可发送红包数
      hongbaoHaveSendNum: 0,// 发送次数
      countdown: 0,  // 发送红包10秒倒计时
      isshowcount: false, // 是否显示10秒倒计时
      timer: null, // 10秒倒计时timer
      closeTimer: null, // 提示框关闭5秒倒计时timer
      closeCount: 5,// 提示框关闭5秒倒计时
      ifshowCount: true,// 是否显示提示框关闭5秒倒计时
      ifShowLater: false// 是否显示提示框later
    }
  },
  props: {
    isShow: Boolean
  },
  computed: {
    ...mapGetters(['roomDetail', 'alertStatus', 'videoBoxStatus', 'cameraStatus', 'screenBoxStatus', 'mediaDisabled', 'hongbaoInfo']),
    userRole () {
      return this.$store.getters.roomDetail.data.roomRole
    },
    getSn () {
      return this.roomDetail.data.lessonSerialNumber
    },
    hongstyle () {
      if (this.hongbaoInfo && this.hongbaoInfo.totalNum <= 0) {
        // 红包禁用
        return false
      } else {
        return true
      }
    },
    hongbaoConfirmState () {
      return this.hongbaoConfirmText !== ''
    },
    hongbaoCloseText () {
      return this.$t('hongbao_close') + "(" + this.closeCount + ")"
    }
  },
  watch: {
    cameraStatus (val) {
      this.videoActive = val
    },
    alertStatus (newVal) {
      if (!newVal) {
        this.settingActive = !this.settingActive
      }
    },
    hongbaoInfo (val) {
      if (val) {
        this.hongbaoNum = this.hongbaoInfo.validNum
        this.hongbaoHaveSendNum = this.hongbaoInfo.totalNum - this.hongbaoInfo.validNum + 1
      }
    }
  },
  created () {
    this.handleVideo = debounce(this.debounceClick, 500)
    this.screenActive = this.screenBoxStatus
    this.fetchGiftData()
  },
  beforeDestroy () {
    this.timer && clearInterval(this.timer)
  },
  methods: {
    ...mapActions([
      'exitMediaSDK',
      'exitSignalSDK',
      'updateRoomStatus',
      'fetchGiftData',
      'getStudentGiftNum'
    ]),
    ...mapMutations([types.UPDATA_ENTER_ROOM_STATUS, types.UPDATA_ISSHOW_MODAL, types.STUDENT_GIFT_MODEL_SHOW]),
    screenBox () {
      this.screenActive = !this.screenActive
      this.$store.commit(types.SCREEN_STATUS, this.screenActive)
      if (this.screenActive) {
        this.$store.commit(types.SET_VIDEO_STATUS, 3)
      } else {
        this.$store.commit(types.SET_VIDEO_STATUS, 1)
      }
    },
    debounceClick () {
      this.videoActive = !this.videoActive
      this.$store.commit(types.MEDIA_CAMERA_STATUS, this.videoActive)
    },
    handleSetting () {
      this.settingActive = !this.settingActive
      this.$store.commit(types.ALERT_STATUS, true)
    },
    // handleCourseManage () {
    //   this.$store.commit(types.COURSE_MANAGE_STATUS, true)
    // },
    openVideoBox () {
      this.$store.commit(types.SET_VIDEO_BOX_STATUS, true)
    },
    openSilenceList () {
      this.silenceListActive = !this.silenceListActive
      this.$store.dispatch('switchShowSilentList', this.silenceListActive)
    },
    clearCanvas () {
      if (this.roomDetail.data.lessonSerialNumber) return
      this.$store.commit(types.CLEAR_SCREEN, true)
    },
    async handleHongbaoModal (e) {
      if (e.target.className.indexOf('opt_toolbar_hongbao_countdown') > -1) {
        return false
      }
      if (!this.hongstyle) {
        // 不可点击
        return false
      }
      if (!this.hongbaoActive) {
        await this.hongbaoBodyTextserver()
      }
      this.hongbaoActive = !this.hongbaoActive
    },
    handleHongbao () {
      let num = this.hongbaoHaveSendNum
      sensorLog.track("teacher_send_hongbao", types.SENSORLOG.type.SUCCESSED, { giftSn: num }) // 数据分析用
      let canvas = this.$refs.canvas
      let cxt = canvas.getContext("2d")

      axios.updataGiftData({ giftSn: num })
        .then((data) => {
          sensorLog.track("update_gift_data", types.SENSORLOG.type.SUCCESSED, JSON.stringify(data))
          this.$nextTick(() => {
            this.hongbaoActive = false // 关闭弹窗
            this.isshowcount = true; // 显示倒计时
            cxt.fillStyle = "rgba(0,0,0,.5)"
            this.drawCountDownCanvas(cxt, 0)
          })
          signalSdk.sendHongbaoData({ gift: { type: 1, id: num } })
            .then((data) => {
              this.timer = setInterval(() => {
                this.countdown++
                this.drawCountDownCanvas(cxt, this.countdown)
                if (this.countdown >= 10) {
                  this.countdown = 0
                  this.isshowcount = false
                  this.fetchGiftData()
                  this.getStudentGiftNum({ giftSn: num })
                    .then(() => {
                      this.$store.commit(types.STUDENT_GIFT_MODEL_SHOW, true)
                    }).catch(() => {
                      this.$store.commit(types.STUDENT_GIFT_MODEL_SHOW, true)
                    })
                  clearInterval(this.timer)
                }
              }, 1000)
            })
            .catch((err) => {
              this.$toast.show({
                text: this.$t('signal'),
                headerDesc: this.$t('attention'),
                buttonCount: 1,
                textStyle: {
                  textAlign: 'center'
                },
                btnText: this.$t('refresh'),
                btnOK: () => {
                  window.location.reload()
                }
              })
            })
        })
        .catch((err) => {
          // 更新红包数失败
          this.hongbaoActive = true // 关闭弹窗
          this.hongbaoBodyText = this.$t('hongbao_send_fail_text')
          this.hongbaoConfirmText = this.$t('hongbao_send_again')
          this.closeCountDown()
          sensorLog.track("update_gift_data", types.SENSORLOG.type.FAILED, JSON.stringify(err))
        })
    },
    drawCountDownCanvas (cxt, i) {
      cxt.clearRect(0, 0, 50, 50)
      cxt.beginPath()
      cxt.moveTo(25, 25)
      if (i >= 10) {
        cxt.clearRect(0, 0, 50, 50)
        return false;
      }
      cxt.arc(
        25,
        25,
        25,
        (Math.PI / 180) * -90,
        (Math.PI / 180) * (-90 + 36 * i),
        true
      )
      cxt.closePath()
      cxt.fill()
    },
    handleHongbaoModalClose () {
      this.closeTimer && clearInterval(this.closeTimer)
      this.hongbaoActive = false
      this.closeCount = 5
      this.ifshowCount = true
      this.ifShowLater = false
    },
    async hongbaoBodyTextserver () {
      let { data } = this.roomDetail
      let { scheduleTime } = data
      let serverTime = await this.getServerTime(data.serverTime)
      if (serverTime < scheduleTime) {
        // 没有到开课时间
        this.hongbaoBodyText = this.$t('hongbao_send_text_beforeclass')
        this.hongbaoConfirmText = ''
        this.closeCountDown()
      } else {
        this.hongbaoBodyText = this.hongbaoNum !== 0 ? this.$t('hongbao_send_text') : this.$t('hongbao_send_empty')
        this.hongbaoConfirmText = this.hongbaoNum !== 0 ? this.$t('hongbao_sure') : ''
        console.log('this.hongbaoNum', this.hongbaoNum)
        if (this.hongbaoNum !== 0) {
          setTimeout(() => {
            this.ifshowCount = false
            this.ifShowLater = true
          }, 0)
          this.hongbaoLaterText = this.$t('hongbao_later')
          console.log('this.hongbaoLaterText', this.hongbaoLaterText)
        } else {
          this.closeCountDown()
        }
      }
    },
    closeCountDown () {
      this.closeCount = 5
      this.ifshowCount = true
      this.ifShowLater = false
      this.closeTimer && clearInterval(this.closeTimer)
      this.closeTimer = setInterval(() => {
        this.closeCount--
        if (this.closeCount === 0) {
          clearInterval(this.closeTimer)
          this.hongbaoActive = false
          this.closeCount = 5
          this.ifshowCount = true
          this.ifShowLater = false
        }
      }, 1000)
    },
    async getServerTime (candidate) {
      let res, serverTime
      try {
        res = await axios.getServerTime()
        serverTime = res.nowtime
      } catch (e) {
        try {
          res = await axios.getServerTime()
          serverTime = res.nowtime
        } catch (e) {
          serverTime = candidate
        }
      }
      return serverTime
    },
    endClass () {
      let self = this
      let title = this.$t('confirmEnd')
      let text = this.$t('endClassTip')
      let headerDesc = this.$t('attention')
      this.$toast.show({
        title,
        text,
        headerDesc,
        buttonCount: 2,
        btnText: this.$t('confirm'),
        btnCancelText: this.$t('btnCancel'),
        btnOK: () => {
          self.updateRoomStatus()
            .then(() => {
              sensorLog.track("update_room_state", types.SENSORLOG.type.SUCCESSED)
              signalSdk.sendTransportData({
                endClass: true
              })
              self[types.UPDATA_ISSHOW_MODAL](true)
              self[types.UPDATA_ENTER_ROOM_STATUS]('AFTER_CLASS')
              Promise.all([self.exitMediaSDK(), self.exitSignalSDK()])
                .then(() => {
                  console.log('退出房间')
                })
            })
            .catch((err) => {
              if (err && err.code === 2062) {
                this.$toast.show({
                  title: '',
                  text: this.$t('DismissClassEarly'),
                  buttonCount: 1,
                  headerDesc: this.$t('attention'),
                  btnText: this.$t('btnok'),
                  textStyle: {
                    'text-align': 'center'
                  },
                  btnOK (e) {
                    // 与上面是同一个是实例，需要去replace
                    console.log(e)
                  }
                })
                return
              }
              this.$nextTick(() => {
                this.$toast.show({
                  title: '',
                  text: this.$t('operationFailuer'),
                  buttonCount: 1,
                  headerDesc: this.$t('attention'),
                  btnText: this.$t('btnok'),
                  textStyle: {
                    'text-align': 'center'
                  },
                  btnOK (e) {
                    // 与上面是同一个是实例，需要去replace
                    console.log(e)
                  }
                })
              })
              sensorLog.track("update_room_state", types.SENSORLOG.type.FAILED, JSON.stringify(err))
            })
        },
        btnCancel () {
          console.log('cancel')
        }
      })
    }
  }
}
</script>
